export const CountryDetailsData = function () {
  return {
    countryDetails: {}
  }
}
